import React from "react";
import HelpTooltip from "../../HelpTooltip.jsx";
import SelectList from "../../SelectList.jsx";

/** Die drei Farbtöne, für die PLAN.md und FORTSCHRITT.md belegte Zahlen führen. */
export const BEISPIEL_ARTIKEL = [
    {value: "327080", label: "327080 – #221 tiefschwarz"},
    {value: "327160", label: "327160 – #231 signalweiß"},
    {value: "327013", label: "327013 – #016 verkehrsrot"},
];

/**
 * Auswahl des Beispiel-Farbtons für die Folien 3, 4 und 6 der Erklärung
 * (Auftrag S7, Standard 327080). Eine gemeinsame Auswahl über alle drei
 * Folien hinweg, damit die Geschichte an einem durchgängigen Beispiel
 * erzählt wird.
 */
export default function BeispielArtikelAuswahl({wert, onChange}) {
    return (
        <div className="d-flex align-items-center gap-2 mb-3">
            <span className="small text-muted flex-shrink-0">Beispiel-Farbton:</span>
            <SelectList value={wert} options={BEISPIEL_ARTIKEL} onChange={onChange} size="sm" ariaLabel="Beispiel-Farbton wählen" style={{minWidth: 240}} />
            <HelpTooltip placement="right" size={0.75}>
                Diese Erklärung rechnet immer mit einem echten Farbton aus dem Sortiment – hier lässt sich zwischen den
                drei Farbtönen wechseln, für die auch der Prüfbericht belegte Zahlen führt.
            </HelpTooltip>
        </div>
    );
}
